<template>
    <div class="etape-container">

        <div class="etape-menu"
             :class="{'menu-active': menuActive}"
        >
            <div
                class="cadre content-cadre background-gray">

                <div class="cadre-tete cadre-tete--menu">

                    <span>Epargnes</span>

                    <router-link
                        :to="$utils.formulaireAller('epargne', 'creer')"
                        tag="div"
                        class="btn btn-ajouter"
                        @click.native="$root.$emit('menuChanger')"
                    >
                        <i class="fas fa-plus-circle"></i>
                        Ajouter un compte
                    </router-link>

                </div>

                <div
                    id="menu"
                    class="cadre-content"
                >
                    <div
                        v-for="element in menu.menu"
                        :key="element.id"
                        class="menu-brique"
                    >

                        <router-link
                            tag="div"
                            :to="$utils.formulaireAller('epargne', element.id)"
                            @click.native="$root.$emit('menuChanger')"
                        >

                            <a class="menu-brique-tete">

                                <div>
                                    <i class="fas fa-university avatar-icon"></i>
                                    {{ element.label }}
                                </div>
                                <i
                                    class="fas fa-trash"
                                    @click="(event) => afficherSuppressionConfirmation(event, element)"
                                ></i>
                            </a>
                            <div class="menu-brique-contenu"
                                 v-if="element.champs && element.champs.length"
                            >
                                <menu-kpis
                                    :kpis="element.champs"
                                    :base-route="$utils.formulaireAller('epargne', element.id)"
                                ></menu-kpis>
                            </div>
                            <div class="menu-brique-pied"
                                v-if="element.meta && element.meta.requis">
                                <completion
                                    :element="element"
                                ></completion>
                            </div>
                        </router-link>

                    </div>

                    <div class="menu-brique brique-creer">
                        <router-link
                            :to="$utils.formulaireAller('epargne', 'creer')"
                            @click.native="$root.$emit('menuChanger')"
                        >
                            <div>
                                <i class="fas fa-university avatar-icon"></i>
                                Nouveau compte
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="etape-content">
            <transition
                name="fade"
                mode="out-in"
            >
                <router-view
                    :key="$route.path"
                    :menu-continuer="menuContinuer"
                ></router-view>
            </transition>
        </div>
        <transition
            name="fade"
            mode="out-in">
            <confirm
                v-if="elementASupprimer"
                status="ask-confirm"
                confirmText="Supprimer"
                :annulerClick="() => elementASupprimer = null"
                :confirmClick="() => supprimer()"
            >
                <div>
                    Souaitez-vous vraiment supprimer <span v-html="elementASupprimer.label"></span>?
                </div>
            </confirm>
        </transition>
    </div>
</template>

<script>
    import api from '@/api'
    import { menuMixin } from '@/utils/formulaire'

    export default {
        name: 'EpargneMenu',
        mixins: [
            menuMixin
        ],
        props: {
            navigation: Array
        },
        data() {
            return {
                elementASupprimer: null
            }
        },
        methods: {
            charger() {
                return api.epargnesMenu({dossierId: this.$route.params.dossierId})
            },
            initialiser() {
                /* on redirige vers le formulaire edition si présent dans l'url */
                const id = this.$route.params.id
                if (id) {
                    this.$router.push(this.$utils.formulaireAller('epargne', id))
                    return
                }

                /* sinon on ouvre automatiquement un nouveau formulaire */
                this.$router.push(this.$utils.formulaireAller('epargne', 'creer'))
            },
            supprimer() {
                api.epargneSupprimer({dossierId: this.$route.params.dossierId, epargneId: this.elementASupprimer.id})
                    .then(() => {
                        this.menuCharger()
                        this.elementASupprimer = null
                    })
            },
            afficherSuppressionConfirmation($event, elem) {
                $event.preventDefault()
                this.elementASupprimer = elem
            },
            menuContinuer(destination) {
                this.menuCharger().then(() => {
                    if (destination === 'enregistrerEtRediriger') {
                        this.$router.push(this.$utils.prochaineEtapeNavigationAller('epargne', this.navigation))
                        return
                    }
                    this.$router.push(this.$utils.prochaineEtapeAller('epargne', this.$route, this.navigation))
                })
            }
        }
    }

</script>

<style lang="scss" scoped>

    .avatar-icon {
        margin-right: 10px;
        font-size: 30px;
    }

    .edit-icon {
        margin-right: 0;
        margin-left: auto;
    }
</style>
